import { render, staticRenderFns } from "./color.vue?vue&type=template&id=fe78dd66&scoped=true&"
import script from "./color.vue?vue&type=script&lang=js&"
export * from "./color.vue?vue&type=script&lang=js&"
import style0 from "./color.vue?vue&type=style&index=0&id=fe78dd66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe78dd66",
  null
  
)

export default component.exports